<template>
    <div class="lvl-page" :class="{ 'is-charm': activeTab === 'charmlevel' }">
        <span class="lvl-aurora" aria-hidden="true"></span>

        <div class="lvl-header">
            <span class="lvl-back" id="close" @click="viewClose('someStatus')">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M19 12H5" />
                    <path d="M12 19l-7-7 7-7" />
                </svg>
            </span>

            <div class="lvl-tabs">
                <button type="button" :class="{ 'is-on': activeTab === 'richlevel' }"
                    @click="activateTab('richlevel')">Rich Level</button>
                <button type="button" :class="{ 'is-on': activeTab === 'charmlevel' }"
                    @click="activateTab('charmlevel')">Charm Level</button>
            </div>
        </div>

        <div class="lvl-inner">
            <!-- Keyed so switching tabs remounts the board and refetches for
                 that type, rather than showing the other tab's figures. -->
            <LevelBoard :key="levelType" :type="levelType" />
        </div>
    </div>
</template>

<script>
import { viewClose as androidViewClose } from '@/utils/android';
import LevelBoard from "./LevelBoard.vue";

/* LevelBoard is imported directly, not as an async component. routes.js pulls
 * LevelComponent into the main bundle, so an async child only bought a second
 * round trip before the skeleton could appear — and it put the page's CSS in
 * that chunk, leaving this header unstyled until it arrived. */
export default {
  name: "LevelComponent",

  components: { LevelBoard },

  data() {
    return {
      activeTab: "richlevel",
    };
  },

  computed: {
    levelType() {
      return this.activeTab === "charmlevel" ? "charm_level" : "rich_level";
    },
  },

  mounted() {
    this.checkURLParams();
  },

  watch: {
    "$route.params.leveltype": "checkURLParams",
  },

  methods: {
    activateTab(tabId) {
      this.activeTab = tabId;
    },

    checkURLParams() {
      // leveltype 1 is charm; anything else falls back to rich.
      this.activeTab = this.$route.params.leveltype === "1" ? "charmlevel" : "richlevel";
    },

    viewClose(status) {
      if (window.Android && typeof window.Android.viewClose === "function") {
        androidViewClose(status);
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.viewClose
      ) {
        window.webkit.messageHandlers.viewClose.postMessage({ status });
      } else {
        window.parent.postMessage({ action: "closePopup", status }, "*");
      }
    },
  },
};
</script>
